// Валідація email та телефону для форм (за зразком admin/src/views/users/UsersForm.js)

export const PHONE_PREFIX = '+380';

// Перевіряє введений email — дозволені тільки букви, цифри, @, ., _, -
export const isValidEmailInput = (value) => /^[a-zA-Z0-9@._-]*$/.test(value);

// Форматує введений телефон у формат +380XXXXXXXXX (тільки цифри, до 9 після +380).
// Якщо поле порожнє — повертає "+380" (префікс завжди присутній).
// Зайвий початковий "0" (локальний формат типу 097...) прибирається.
export const formatPhoneInput = (value) => {
	if (!/^\+?[\d]*$/.test(value)) return null;
	if (value === '') return PHONE_PREFIX;

	let digits = value.startsWith(PHONE_PREFIX)
		? value.slice(4).replace(/\D/g, '')
		: value.replace(/\D/g, '');

	if (digits.startsWith('0')) digits = digits.slice(1);
	digits = digits.slice(0, 9);

	return PHONE_PREFIX + digits;
};

// Перевіряє, що телефон не введено (порожньо або тільки "+380") або має повний формат +380XXXXXXXXX (9 цифр)
export const isValidPhoneInput = (value) => {
	const trimmed = value.trim();
	return trimmed === '' || trimmed === PHONE_PREFIX || /^\+380\d{9}$/.test(trimmed);
};

// Значення для відправки на API: undefined, якщо телефон фактично не введено
export const phoneForApi = (value) => {
	const trimmed = value.trim();
	return (trimmed === '' || trimmed === PHONE_PREFIX) ? undefined : trimmed;
};
